export default __webpack_public_path__ + "static/media/editweb.e7c8aa99.svg";